export default getText => key =>
  ({
    subtext: getText('© All rights reserved. 2020 Medvice B.V. enterprise', 'Auth_Footer'),
    privacy: getText('Privacy Policy', 'Auth_Footer'),
    terms: getText('Terms & Condition', 'Auth_Footer'),
  }[key])
